module.exports = __webpack_public_path__ + "media/1x1/bv-b70ab2f2.svg";